// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2SGeg","alertIcon":"ConfirmModal_alertIcon__3mQ8h"};